import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconCloseCircleSvg } from './IconCloseCircleSvg';

export const IconCloseCircle: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconCloseCircleSvg} {...iconProps} />;
};
